// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"486":"60d48beb","873":"fda64ae6","902":"81cb5167"}[chunkId] + ".chunk.css";
};